import {
  REGULARIZATION_PERIOD_CREDITS_BANNER_TEXTS,
  SUBSCRIPTION_PLAN_BANNER_TEXTS,
} from 'app/constants/subscriptionBannerTexts';

export const PERFIL_TEXTS = {
  tabs: {
    profile_info: 'Informações',
    financial: 'Assinatura',
    change_password: 'Alterar Senha',
    credit_cards: 'Cartões',
    edit_report: 'Editar Relatório',
  },

  changePassword: {
    title: 'Alterar Senha',
    currentPassword: 'Senha atual',
    newPassword: 'Nova senha',
    confirmPassword: 'Confirmar senha',
    button: 'ALTERAR',
    success: 'Senha alterada com sucesso!',
    errors: {
      required: 'Campo obrigatório',
      currentPasswordRequired: 'Informe sua senha atual.',
      confirmPasswordRequired: 'Digite a confirmação da senha!',
      mismatch: 'As senhas não coincidem!',
      generic: 'Ocorreu um erro ao alterar a senha. Tente novamente.',
    },
  },

  mySubscription: {
    cancelPlan: 'CANCELAR PLANO',
    status: 'Status',
    value: 'Valor',
    startPeriod: 'INÍCIO DO PERÍODO',
    endPeriod: 'FIM DO PERÍODO',
    paymentMethod: 'FORMA DE PAGAMENTO',
    creditCard: 'CARTÃO DE CRÉDITO',
    boleto: 'BOLETO',
    accessBoleto: 'ACESSAR BOLETO',
    cardBrand: 'BANDEIRA DO CARTÃO',
    cardLastDigits: 'ÚLTIMOS DÍGITOS DO CARTÃO',
    errorCard: 'Não foi possível validar o seu cartão de crédito.',
    statusList: {
      trialing: 'Período de Teste',
      paid: 'Ativo',
      Paga: 'Ativo',
      active: 'Ativo',
      unpaid: 'Pagamento Pendente',
      'Não Pago': 'Pagamento Pendente',
      canceled: 'Cancelado',
      Cancelado: 'Cancelado',
      waiting_payment: 'Aguardando Pagamento',
      pending_payment: 'Pendente Pagamento',
      failed: 'Falha no Pagamento',
    },
  },

  currentPlanSummary: {
    planLabel: 'PLANO CONTRATADO',
    valueLabel: 'Valor',
    valueLastLabel: 'VALOR DA ÚLTIMA MENSALIDADE',
    startPeriod: 'INÍCIO DO PERÍODO',
    endPeriod: 'FIM DO PERÍODO',
    paymentMethod: 'FORMA DE PAGAMENTO',
    creditCard: 'CARTÃO DE CRÉDITO',
    pix: 'PIX',
    boleto: 'BOLETO',
    cardBrandLabel: 'BANDEIRA DO CARTÃO',
    cardLastDigitsLabel: 'ÚLTIMOS DÍGITOS DO CARTÃO',
    cancelPlan: 'CANCELAR PLANO',
    reactivatePlan: 'REATIVAR PLANO',
    status: {
      active: 'Ativo',
      inactive: 'Inativo',
    },
    actions: {
      cancelAccount: 'CANCELAR CONTA',
    },
  },

  creditCardManager: {
    title: 'Gerencie seus cartões de crédito cadastrados',
    emptyMessage:
      'Clique no botão abaixo para adicionar um cartão de crédito vinculado à sua conta.',
    addCardButton: 'ADICIONAR CARTÃO',
    deleteModal: {
      title: 'Excluir cartão',
      description:
        'Deseja realmente excluir este cartão? Esta ação é irreversível.',
      confirmButton: 'Excluir',
      cancelButton: 'Cancelar',
    },
  },

  addCreditCard: {
    title: 'Adicionar cartão de crédito',
    cardholderName: 'Nome impresso no cartão',
    cardNumber: 'Número do cartão',
    expiration: 'Vencimento',
    cvv: 'CVV',
    addButton: 'Adicionar cartão',
    errors: {
      cardholderName: 'Verifique o nome impresso no cartão.',
      cardNumber: 'Verifique o número do cartão.',
      expiration: 'Verifique a data de expiração do cartão.',
      cvv: 'Verifique o código de segurança (CVV) do cartão.',
      generic: 'Falha ao adicionar cartão. Por favor, tente novamente.',
    },
  },

  subscriptionUpgrade: {
    title: 'Upgrade Plano',
    contractAnotherPlan: 'Contratar outro plano',
    choosePlan: 'Escolha agora seu plano',
    subtitle: 'Basta escolher um plano para realizar o upgrade agora mesmo',
    monthly: 'Mensal',
    annual: 'Anual',
    noUpgradeAvailable:
      'Você já está no nosso plano mais completo. Para dúvidas sobre limites ou upgrades adicionais, contate o suporte.',
    statusUnavailable:
      'Não foi possível carregar os dados da sua assinatura. Tente novamente em instantes.',
    plans: {
      starter: {
        description:
          'Plano Inicial básico para advogados iniciando a carreira.',
      },
      master: {
        description:
          'Plano completo para você. Tenha acesso a todas ferramentas necessárias para o seu escritório.',
      },
      ultimate: {
        description:
          'Plano Ultimate. Tenha acesso a todas ferramentas com mais benefícios ainda.',
      },
    },
    checkout: {
      title: 'Checkout',
      cardholderName: 'Nome impresso no cartão',
      cardNumber: 'Número do cartão',
      expiration: 'Vencimento',
      cvv: 'CVV',
      useExistingCard: 'Desejo utilizar meu cartão com final',
      manualCard: 'Desejo informar os dados do cartão manualmente',
      signNowButton: 'Assinar agora',
    },
    success: {
      title: 'Parabéns, sua assinatura foi atualizada com sucesso!',
      continueButton: 'CONTINUAR NAVEGANDO',
    },
  },
  cancelPlan: {
    title: 'PRECISA DE AJUDA COM O SEU PLANO?',
    cancel: 'CANCELAR PLANO',
    help: 'FALAR COM SUPORTE',
  },

  cancelFlow: {
    retentionOffer: {
      success:
        'Condição especial ativada! Você continua na Jusfy com sua assinatura ativa.',
    },
  },

  planChangedModal: {
    title: 'Plano Alterado',
    description:
      'Seu plano foi reativado com sucesso, mas houve uma alteração:',
    oldPlan: 'Plano anterior',
    newPlan: 'Novo plano',
    understandButton: 'Entendi',
    message:
      'O plano anterior não estava mais disponível ou o período promocional expirou. Seu novo plano oferece as mesmas funcionalidades.',
  },

  userInformation: {
    profession: 'Profissão',
    cpf: 'CPF',
    fullName: 'Nome completo',
    phone: 'Telefone',
    email: 'E-mail',
    oab: 'Nº da OAB',
    oabState: 'Estado da OAB',
    cep: 'CEP',
    state: 'Estado',
    city: 'Cidade',
    address: 'Endereço',
    district: 'Bairro',
    saveButton: 'SALVAR',
    addressComplement: 'Complemento',
    addressNumber: 'Número',
  },

  subscriptionStatusBanner: {
    ...SUBSCRIPTION_PLAN_BANNER_TEXTS,
    loadingText: 'Reativando...',
    messages: {
      ...SUBSCRIPTION_PLAN_BANNER_TEXTS.messages,

      paid:
        'Seu plano está ativo e funcionando normalmente. Aproveite todos os recursos disponíveis.',
      trialing:
        'Você está no período de teste. Explore todas as funcionalidades antes de escolher um plano.',
      ok:
        'Seu plano está funcionando perfeitamente. Continue aproveitando todos os recursos disponíveis.',
      active:
        'Sua assinatura está ativa. Todos os recursos estão disponíveis para uso.',

      trial_expired_but_active:
        'O período de teste terminou mas seu acesso ainda está ativo. Escolha um plano para continuar após a data de expiração.',

      server_error:
        'Erro temporário ao verificar seu status. Tente novamente em alguns instantes.',
      no_subscription_data:
        'Não foi possível verificar seu status de assinatura. Entre em contato com o suporte.',
      unknown_status:
        'Status de assinatura não reconhecido. Entre em contato com o suporte para regularização.',
      plan_canceled:
        'Seu plano foi cancelado. Reative sua assinatura para manter o acesso aos recursos.',
      payment_failed:
        'Falha no processamento do pagamento. Atualize seus dados de pagamento para continuar.',
      loading: 'Verificando status da sua assinatura...',
    },
  },

  regularizationPeriodCreditsBanner: REGULARIZATION_PERIOD_CREDITS_BANNER_TEXTS,

  regularizeCardPaymentModal: {
    newCardPrimaryDisclaimer:
      'O novo cartão cadastrado será definido como cartão principal da sua assinatura. Você pode alterar o cartão principal a qualquer momento na aba Cartões.',
  },

  reactivationSuccessModal: {
    header: {
      congratulations: 'Parabéns! 🎉',
      subtitle: 'Seu plano foi reativado com sucesso',
    },
    content: {
      title: 'Você fez uma excelente escolha!',
      previousPlan: 'Plano Anterior',
      newPlan: 'Novo Plano',
      perMonth: 'por mês',
      noDataAvailable: 'Dados não disponíveis',
      savings: {
        title: '💰 Você economizou!',
        subtitle: 'por mês em comparação ao plano anterior',
      },
      finalMessage:
        'Agora você pode aproveitar ao máximo todas as funcionalidades da plataforma!',
    },
    actions: {
      continueButton: 'Continuar para o Dashboard',
    },
  },

  creditCardValidation: {
    required: {
      cardholderName: 'O nome do titular do cartão é obrigatório.',
      cardNumber: 'O número do cartão é obrigatório.',
      cardExpiration: 'O mês/ano de expiração do cartão é obrigatório.',
      cardCvv: 'O código de segurança (CVV) do cartão é obrigatório.',
    },
    format: {
      cardholderName: 'Verifique o nome impresso no cartão.',
      cardNumber: 'Verifique o número do cartão.',
      cardExpiration: 'Verifique a data de expiração do cartão.',
      cardCvv: 'Verifique o código de segurança (CVV) do cartão.',
    },
    specific: {
      invalidExpiration: 'O vencimento é inválido.',
      invalidCvv: 'Número do CVV inválido.',
      invalidCardNumber: 'Número do cartão inválido.',
      expiredCard: 'Cartão expirado.',
    },
    labels: {
      cardholderName: 'Nome impresso no cartão',
      cardNumber: 'Número do cartão',
      cardExpiration: 'Vencimento (MM/AA)',
      cardCvv: 'CVV',
      required: 'Obrigatório',
    },
    errors: {
      processingError: 'Erro ao processar o cartão. Tente novamente.',
      invalidServerResponse: 'Resposta inválida do servidor',
      cardProcessingError: 'Erro ao processar o cartão',
    },
  },
  warnPrePaidPlanExpiration: {
    title: 'Seu plano pré-pago expirou!',
    message:
      'Sua assinatura está disponível para renovação. Finalize o pagamento por Pix ou cartão de crédito e continue usando a Jusfy normalmente.',
    reactivateButton: 'Pagar fatura',
  },
  promotionalPlanInfo: {
    message:
      'Contratação trimestral do Plano Ultimate por R$19,90/mês durante os três primeiros meses. Cobrança imediata.',
    info:
      'A partir do quarto mês, a assinatura será ajustada automaticamente para o valor normal do plano Ultimate(R$117/ mês).',
    clients: 'Válido para clientes selecionados.',
  },
};
